import * as React from "react";
import LoginPage from "./pages/LoginPage";

import { RouteProps } from "react-router";
import LandingPage from "./pages/LandingPage";
import { withProps } from "recompose";
import QuadPage from "./pages/QuadPage";
import RegistrationPage from "./pages/RegistrationPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import QuestionAnswerFragment from "./pages/QuestionAnswerFragment";
import PrivacyPage from "./pages/PrivacyPage";
import BusinessPlanPage from "./pages/BusinessPlanPage";
import ProductSheetPage from "./pages/ProductSheetPage";

import withTracker from "./helpers/withTracker";
import AdminEditor from "./pages/AdminEditor";
import { LoggedInRedirect } from "./helpers/WithLoggedIn";
import OverviewPage from "./pages/OverviewPage";
//PLOP_INSERT_IMPORT_ROUTE
interface RouteConfig extends RouteProps {
	routes?: RouteConfig[];
}

const makeQuadSubRoutes = infoKey => [
	{
		path: `/${infoKey}/:id/answer`,
		component: withProps({ infoKey: `${infoKey}` })(QuestionAnswerFragment)
	},
	{
		path: `/${infoKey}/overview`,
		component: withProps({ infoKey: infoKey })(OverviewPage)
	},
	{
		path: `/${infoKey}`,
		component: withProps({ infoKey: `${infoKey}` })(QuadPage),
		routes: []
	}
];

export const routes: RouteConfig[] = [
	{
		path: "/admin-edit",
		component: AdminEditor
	},
	{
		path: "/businessplan",
		component: BusinessPlanPage
	},
	{
		path: "/privacy",
		component: PrivacyPage
	},
	{
		path: "/register",
		component: LoggedInRedirect(RegistrationPage)
	},
	{
		path: "/login",
		component: LoggedInRedirect(LoginPage)
	},
	{
		path: "/forgot",
		component: ForgotPasswordPage
	},
	{
		path: "/products",
		component: ProductSheetPage
	},
	...makeQuadSubRoutes("owners"),
	...makeQuadSubRoutes("strategy"),
	...makeQuadSubRoutes("operations"),
	...makeQuadSubRoutes("marketing"),
	//PLOP_INSERT_ROUTE
	{
		path: "/",
		component: LandingPage,
		exact: true
	},
	{
		path: "/",
		component: () => <p>404</p>
	}
];



// WEBPACK FOOTER //
// ./src/Routes.tsx